import { BenchmarkPortfolio, InputPortfolio } from '@blk/wealth-web-endpoint';
import { AnalysisParams, PortfolioAnalysisParams } from '@ddt-web/data-service';
import * as get from 'lodash/get';
import * as isEmpty from 'lodash/isEmpty';

import { mapPortfolioAnalysisBenchmarkRequestToBenchmarkPortfolio, mapPortfolioAnalysisRequestToInputPortfolios } from '../domain/requests/portfolio-analysis-request-mappings';

export class WealthWebApiParamUtil {


	public static createPortfolioParams(portfolios: Array<PortfolioAnalysisParams>, useAladdinId: boolean = false): Array<InputPortfolio> {
		return mapPortfolioAnalysisRequestToInputPortfolios(portfolios || [], useAladdinId);
	}

	public static createBenchmarkParam(analysisParams: AnalysisParams, useAladdinId: boolean = false): BenchmarkPortfolio {
		let benchmarkPortfolio;
		if (analysisParams?.benchmark) {

			if (isEmpty(get(analysisParams, 'benchmark.positions'))) {
				benchmarkPortfolio = get(analysisParams, 'analysisParamsArray', []).filter(port => port.uniqueId === get(analysisParams, 'benchmark.id'))[0];
			} else {
				const engagementBenchmark = analysisParams.benchmark;
				benchmarkPortfolio = new PortfolioAnalysisParams(get(engagementBenchmark, 'id'), null, get(engagementBenchmark, 'positions'), null, get(engagementBenchmark, 'currency'));
			}

			return mapPortfolioAnalysisBenchmarkRequestToBenchmarkPortfolio(benchmarkPortfolio, useAladdinId);
		}
		return benchmarkPortfolio;
	}
}
